
<template>
<vs-card id="add-client-loading" class="vs-con-loading__container">
  <form-wizard color="rgba(var(--vs-primary), 1)" :title="null" :subtitle="null" finishButtonText="Submit" @on-complete="formSubmitted">
    <template slot="step" slot-scope="props">
      <wizard-step :tab="props.tab" :transition="props.transition" :key="props.tab.title" :index="props.index">
      </wizard-step>
    </template>

    <template slot="footer" slot-scope="props">
      <div class="wizard-footer-left">
        <!-- <wizard-button v-if="props.activeTabIndex > 0 && !props.isLastStep" @click.native="props.prevTab()" :style="props.fillButtonStyle">Previous</wizard-button> -->

        <vs-button v-if="props.activeTabIndex > 0" @click.native="props.prevTab()" color="primary" type="filled" icon-pack="feather" icon="Check"> {{ $t('previous') | capitalize }}
        </vs-button>
      </div>
      <div class="wizard-footer-right">
        <!-- <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab()" class="wizard-footer-right" :style="props.fillButtonStyle">Next</wizard-button> -->
        <!-- <vs-button v-if="!props.isLastStep" @click.native="props.nextTab()" :disabled="disabledSubmit" color="primary" type="filled" icon-pack="feather" icon="Check"> {{ $t('next') | capitalize }}
        </vs-button> -->
        <vs-button v-if="props.activeTabIndex === 0" @click.native="props.nextTab()" :disabled="disabledSubmitCompany" color="primary" type="filled" icon-pack="feather" icon="Check"> {{ $t('next') | capitalize }}
        </vs-button>
        <vs-button v-else-if="props.activeTabIndex === 1" @click.native="props.nextTab()" :disabled="disabledSubmitHeadquarter" color="primary" type="filled" icon-pack="feather" icon="Check"> {{ $t('next') | capitalize }}
        </vs-button>
        <vs-button v-else-if="props.activeTabIndex === 2" @click.native="props.nextTab()" :disabled="disabledSubmitClient" color="primary" type="filled" icon-pack="feather" icon="Check"> {{ $t('next') | capitalize }}
        </vs-button>
        <vs-button v-else-if="props.activeTabIndex === 3" @click.native="props.nextTab()" color="primary" type="filled" icon-pack="feather" icon="Check"> {{ $t('next') | capitalize }}
        </vs-button>
        <vs-button v-else @click="formSubmitted" color="primary" type="filled" icon-pack="feather" icon="Check"> {{ $t('done') | capitalize }}
        </vs-button>
        <!-- <wizard-button v-else @click.native="alert('Done')" class="wizard-footer-right finish-button" :style="props.fillButtonStyle"> {{props.isLastStep ? 'Done' : 'Next'}}</wizard-button> -->
      </div>
    </template>

    <!-- tab 1 -->
    <tab-content :title="$t('company') | capitalize" class="mb-5" icon="feather icon-award" :before-change="checkCompany">
      <!-- tab 1 content -->
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mt-5">
          <label for="">{{$t('company')| capitalize}}</label>
          <v-select v-model="selectedCompany" class="w-full" label="name" :placeholder="$t('company') | capitalize" :options="companies" :reduce="item => item.id" :clearable="false" />
        </div>
      </div>

      <div class="vx-row mt-5 mx-2">
        <div class="vx-col w-full text-center text-primary">
          <div class="linea">&nbsp;</div>
          <div class="leyenda"> {{ $t('or_new_company') | capitalize }}</div>
          <div class="linea">&nbsp;</div>
        </div>
      </div>
      <!-- <hr class="mt-5 text-primary" /> -->
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-full mt-5">
          <vs-input :label="$t('name') | capitalize" v-model="company.name" class="w-full" name="Company Name" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Company Name')">{{ errors.first('Company Name') }}</span>
        </div>
        <div class="vx-col md:w-1/3 w-full mt-5">
          <vs-input :label="$t('rfc') | upperCase" v-model="company.rfc" class="w-full" @input="company.rfc= company.rfc.toUpperCase();" name="RFC" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('RFC')">{{ errors.first('RFC') }}</span>
        </div>
        <div class="vx-col md:w-1/3 w-full mt-5">
          <vs-input :label="$t('representative') | capitalize" v-model="company.representative" class="w-full" name="Representative" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Representative')">{{ errors.first('Representative') }}</span>
        </div>
        <div class="vx-col md:w-1/3 w-full mt-5">
          <vs-input :label="$t('manager_name') | capitalize" v-model="company.managerName" class="w-full" name="Manager Name" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Manager Name')">{{ errors.first('Manager Name') }}</span>
        </div>
        <div class="vx-col md:w-1/3 w-full mt-5">
          <vs-input type="email" :label="$t('manager_email') | capitalize" v-model="company.managerEmail" class="w-full" name="Manager Email" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Manager Email')">{{ errors.first('Manager Email') }}</span>
        </div>
        <div class="vx-col md:w-1/3 w-full mt-5">
          <vs-input :label="$t('manager_phone') | capitalize" v-model="company.managerPhone" class="w-full" name="Manager Phone" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Manager Phone')">{{ errors.first('Manager Phone') }}</span>
        </div>
        <div class="vx-col md:w-1/3 w-full mt-5">
          <vs-input :label="$t('address') + ' 1' | capitalize" v-model="company.address1" class="w-full" name="Company Address 1" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Company Address 1')">{{ errors.first('Company Address 1') }}</span>
        </div>
        <div class="vx-col md:w-1/3 w-full mt-5">
          <vs-input :label="$t('address') + ' 2' | capitalize" v-model="company.address2" class="w-full" name="Address 2" />
        </div>
        <div class="vx-col md:w-1/3 w-full mt-5">
          <vs-input :label="$t('number') | capitalize" v-model="company.addressNumber" class="w-full" name="Company Addres Number" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Company Addres Number')">{{ errors.first('Company Addres Number') }}</span>
        </div>
        <div class="vx-col md:w-1/3 w-full mt-5">
          <vs-input :label="$t('state') | capitalize" v-model="company.addressState" class="w-full" name="Company Address State" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Company Address State')">{{ errors.first('Company Address State') }}</span>
        </div>
        <div class="vx-col md:w-1/3 w-full mt-5">
          <vs-input :label="$t('city') | capitalize" v-model="company.addressCity" class="w-full" name="Company Address City" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Company Address City')">{{ errors.first('Company Address City') }}</span>
        </div>
        <div class="vx-col md:w-1/3 w-full mt-5">
          <vs-input :label="$t('zip') | capitalize" v-model="company.addressZip" class="w-full" name="Company Address Zip" v-validate="'required|min:5'" />
            <span class="text-danger text-sm" v-show="errors.has('Company Address Zip')">{{ errors.first('Company Address Zip') }}</span>
        </div>
        <div class="vx-col  w-full mt-6">
          <vs-checkbox v-model="company.check" class="mt-6">Check if information is correct.</vs-checkbox>
        </div>
      </div>
    </tab-content>
    <!-- tab 2 -->
    <tab-content :title="$t('headquarter') | capitalize" class="mb-5" icon="feather icon-home" :before-change="checkHeadquarter">
      <!-- tab 2 content -->
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-full mt-5">
          <vs-input :label="$t('name') | capitalize" v-model="headquarter.name" class="w-full" name="Headquarter Name" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Headquarter Name')">{{ errors.first('Headquarter Name') }}</span>
        </div>
        <div class="vx-col md:w-1/3 w-full mt-5">
          <vs-input :label="$t('address') + ' 1' | capitalize" v-model="headquarter.address1" class="w-full" name="Headquarter Address 1" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Headquarter Address 1')">{{ errors.first('Headquarter Address 1') }}</span>
        </div>
        <div class="vx-col md:w-1/3 w-full mt-5">
          <vs-input :label="$t('address') + ' 2' | capitalize" v-model="headquarter.address2" class="w-full" name="Headquarter Address 2"/>
        </div>
        <div class="vx-col md:w-1/3 w-full mt-5">
          <vs-input :label="$t('city') | capitalize" v-model="headquarter.addressCity" class="w-full" name="Headquarter City" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Headquarter City')">{{ errors.first('Headquarter City') }}</span>
        </div>
        <div class="vx-col md:w-1/3 w-full mt-5">
          <vs-input :label="$t('zip') | capitalize" v-model="headquarter.addressZip" class="w-full" name="Headquarter Address Zip" v-validate="'required|min:5'" />
            <span class="text-danger text-sm" v-show="errors.has('Headquarter Address Zip')">{{ errors.first('Headquarter Address Zip') }}</span>
        </div>
      </div>
    </tab-content>
    <!-- tab 3 -->
    <tab-content :title="$t('client') | capitalize" class="mb-5" icon="feather icon-user" :before-change="checkClient"  :style="{height:'55vh'}">
      <!-- tab 3 content -->
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-full mt-5">
          <vs-input :label="$t('name') | capitalize" v-model="client.name" class="w-full" name="Client Name" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Client Name')">{{ errors.first('Client Name') }}</span>
        </div>
        <div class="vx-col md:w-1/3 w-full mt-5">
          <vs-input :label="$t('short_name') | capitalize" v-model="client.shortName" class="w-full" name="Client Short Name" v-validate="'required'" @input="setScaFileName"/>
            <span class="text-danger text-sm" v-show="errors.has('Client Short Name')">{{ errors.first('Client Short Name') }}</span>
        </div>
        <div class="vx-col md:w-1/3 w-full mt-5">
          <vs-input :label="$t('sca_file_name') | capitalize" v-model="client.scaFileName" class="w-full" name="SCA File Name" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('SCA File Name')">{{ errors.first('SCA File Name') }}</span>
        </div>
        <div class="vx-col md:w-1/3 w-full mt-5">
          <vs-input :label="$t('mxn_funds_transfer') | capitalize" v-model="client.mxnFundsTransferInfo" class="w-full" name="MXN Funds Transfer Info" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('MXN Funds Transfer Info')">{{ errors.first('MXN Funds Transfer Info') }}</span>
        </div>
        <div class="vx-col md:w-1/3 w-full mt-5">
          <vs-input :label="$t('usd_funds_transfer') | capitalize" v-model="client.usdFundsTransferInfo" class="w-full" name="USD Funds Transfer Info" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('USD Funds Transfer Info')">{{ errors.first('USD Funds Transfer Info') }}</span>
        </div>
        <div class="vx-col md:w-1/3 w-full mt-5">
          <label for="">{{$t('schedule_day_invoice') | capitalize}}</label>
          <v-select v-model="client.scheduleDayInvoice" class="w-full" label="name" :placeholder="$t('schedule_day_invoice') | capitalize" :options="days" :reduce="item => item.id" :clearable="false" />
        </div>
        <div class="vx-col md:w-1/3 w-full mt-5">
          <vs-input :label="$t('warehouse_code') | capitalize" v-model="client.code" class="w-full" name="Code" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Code')">{{ errors.first('Code') }}</span>
        </div>
        <div class="vx-col md:w-1/3 w-full mt-5">
          <vs-input :label="$t('darwin_account') | capitalize" v-model="client.darwinAccount" class="w-full" name="Darwin Account" />
            <!-- <span class="text-danger text-sm" v-show="errors.has('Darwin Account')">{{ errors.first('Darwin Account') }}</span> -->
        </div>
        <div class="vx-col md:w-1/3 w-full mt-5">
          <v-swatches v-model="client.color" show-fallback fallback-input-type="color" popover-x="left"  popover-y="bottom" class="w-full">
            <vs-input slot="trigger" :label="$t('color') | capitalize" v-model="client.color" class="w-full" readonly :style="{color:client.color}" />
          </v-swatches>
        </div>
      </div>
      </div>
    </tab-content>
    <!-- tab 4 -->
    <tab-content :title="$t('recipients') | capitalize" class="mb-5" icon="feather icon-mail">
      <!-- tab 4 content -->
      <recipient-list v-model="recipients" />
    </tab-content>
    <!-- tab 5 -->
    <tab-content :title="$t('resume') | capitalize" class="mb-5" icon="feather icon-file-text">
    <client-resume :client="client" :companyInfo="companyInfo" :headquarter="headquarter" :recipients="recipients" />
    </tab-content>
  </form-wizard>
</vs-card>
</template>

<script>
import {
  FormWizard,
  WizardStep,
  TabContent
} from 'vue-form-wizard'

import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import RecipientList from './components/RecipientList'
import loading from '@/mixins/Loading'
import validate from '@/mixins/Validate'
import client from '@/http/requests/client'
import VSwatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.css'

import ClientResume from './components/ClientResume'
import vSelect from 'vue-select'
export default {
  components: {
    FormWizard,
    WizardStep,
    TabContent,
    RecipientList,
    VSwatches,
    ClientResume,
      'v-select': vSelect,
  },
  computed: {
    isLoading() {
      return this.loading.company || this.loading.checkCompany || this.loading.checkHeadquarter || this.loading.checkClient || this.loading.submit;
    },
    disabledSubmitCompany() {
      if (this.selectedCompany === '00' && this.company.check === false) {
        return true
      }

      if (this.company.check === true) {
        return this.errors.any() ||
          this.company.name === '' ||
          this.company.rfc === '' ||
          this.company.representative === '' ||
          this.company.managerName === '' ||
          this.company.managerEmail === '' ||
          this.company.managerPhone === '' ||
          this.company.address1 === '' ||
          this.company.addressNumber === '' ||
          this.company.addressState === '' ||
          this.company.addressCity === '' ||
          this.company.addressZip === ''
      }
    },
    disabledSubmitHeadquarter() {
      return this.errors.any() ||
        this.headquarter.name === '' ||
        this.headquarter.address1 === '' ||
        this.headquarter.address2 === '' ||
        this.headquarter.addressCity === '' ||
        this.headquarter.addressZip === ''
    },
    disabledSubmitClient() {
      return this.errors.any() ||
      this.client.name === '' ||
      this.client.shortName === '' ||
      this.client.scaFileName === '' ||
      this.client.mxnFundsTransferInfo === '' ||
      this.client.usdFundsTransferInfo === '' ||
      this.client.scheduleDayInvoice === '' ||
      this.client.code === '' ||
      this.client.color === ''
    },
  },

  data: () => ({
    days: [{
        id: '2',
        name: 'Tuesday - 5 AM'
      },
      {
        id: '3',
        name: 'Wednesday - 5 AM'
      }
    ],
    companies: [{
      id: '00',
      name: 'Select Company'
    }],
    selectedCompany: '',
    companyInfo: {
      name: '',
      rfc: '',
      representative: '',
      managerName: '',
      managerEmail: '',
      managerPhone: '',
      address1: '',
      address2: '',
      addressNumber: '',
      addressState: '',
      addressCity: '',
      addressZip: '',
      check: false
    },
    company: {
      name: '',
      rfc: '',
      representative: '',
      managerName: '',
      managerEmail: '',
      managerPhone: '',
      address1: '',
      address2: '',
      addressNumber: '',
      addressState: '',
      addressCity: '',
      addressZip: '',
      check: false
    },
    headquarter: {
      name: '',
      address1: '',
      address2: '',
      addressCity: '',
      addressZip: '',
      managerName: '',
      managerEmail: '',
      managerPhone: ''
    },
    client: {
      name: '',
      shortName: '',
      scaFileName: '',
      mxnFundsTransferInfo: '',
      usdFundsTransferInfo: '',
      scheduleDayInvoice: '',
      code: '',
      darwinAccount: '',
      color: '#000000'
    },
    recipients: [],
    loading: {
      company: false,
      checkClient: false,
      checkCompany: false,
      checkHeadquarter: false,
      submit: false
    }
  }),

  methods: {
    getCompanies() {
      this.loading.company = true
      client.getCompanies()
        .then((res) => {
          this.companies.push(...res.data.companies)
          this.selectedCompany = this.companies[0].id
          this.loading.company = false
        })
        .catch((res) => {
          this.loading.company = false
        })
    },
    formSubmitted() {
      let form = new FormData()

      let params={
        company:this.company,
        client:this.client,
        recipients:this.recipients,
        headquarter:this.headquarter,
        CompanyId:this.selectedCompany
      }
      this.loading.submit = true
      client.storeClient(params)
      .then((res) => {
        this.$vs.notify({
          color: 'success',
          title: this.$i18n.messages[this.$i18n.locale].success,
          text: this.$i18n.messages[this.$i18n.locale].client_saved
        })
        this.loading.submit = false
        this.$router.push({
          name: 'clients'
        });

      })
      .catch( (res) => {
        this.displayErrors(res)
        this.loading.submit = false
      })
    },
    checkCompany() {
      this.$validator.reset()

      this.headquarter.managerName = this.company.managerName
      this.headquarter.managerEmail = this.company.managerEmail
      this.headquarter.managerPhone = this.company.managerName

      if (this.selectedCompany !== '00' && this.company.check === false) {
        this.loading.company = true
        return client.getCompany(this.selectedCompany)
          .then((res) => {
            this.companyInfo.name = res.data.item.CompanyName
            this.companyInfo.rfc = res.data.item.RFC
            this.companyInfo.representative = res.data.item.Representative
            this.companyInfo.managerName = res.data.item.ManagerName
            this.companyInfo.managerEmail = res.data.item.ManagerEmail
            this.companyInfo.managerPhone = res.data.item.ManagerPhone
            this.companyInfo.address1 = res.data.item.Address1
            this.companyInfo.address2 = res.data.item.Address2
            this.companyInfo.addressNumber = res.data.item.AddressNumber
            this.companyInfo.addressState = res.data.item.AddressState
            this.companyInfo.addressCity = res.data.item.AddressCity
            this.companyInfo.addressZip = res.data.item.AddressZip

            this.headquarter.address1 = this.companyInfo.address1
            this.headquarter.address2 = this.companyInfo.address2
            this.headquarter.addressCity = this.companyInfo.addressCity
            this.headquarter.addressZip = this.companyInfo.addressZip
            this.headquarter.managerName = this.companyInfo.managerName
            this.headquarter.managerEmail = this.companyInfo.managerEmail
            this.headquarter.managerPhone = this.companyInfo.managerName

            this.loading.company = false
            return true
          })
          .catch((res) => {
            this.loading.company = false
            return false
          })
      }


      let data = {
        CompanyName: this.company.name,
        RFC: this.company.rfc,
        Representative: this.company.representative,
        ManagerName: this.company.managerName,
        ManagerEmail: this.company.managerEmail,
        ManagerPhone: this.company.managerPhone,
        Address1: this.company.address1,
        Address2: this.company.address2,
        AddressNumber: this.company.addressNumber,
        AddressState: this.company.addressState,
        AddressCity: this.company.addressCity,
        AddressZip: this.company.addressZip,
        check: false
      }

      this.loading.checkCompany = true

      return client.checkCompany(data)
        .then((res) => {
          this.loading.checkCompany = false
          this.companyInfo = Object.assign({}, this.company)
          this.headquarter.address1 = this.companyInfo.address1
          this.headquarter.address2 = this.companyInfo.address2
          this.headquarter.addressCity = this.companyInfo.addressCity
          this.headquarter.addressZip = this.companyInfo.addressZip
          return res.data.validated
        })
        .catch((res) => {
          this.displayErrors(res);
          this.loading.checkCompany = false
          return false
        })
    },

    checkHeadquarter() {
      this.$validator.reset()
      let data = {
        HeadquarterName: this.headquarter.name,
        Address1: this.headquarter.address1,
        Address2: this.headquarter.address2,
        AddressCity: this.headquarter.addressCity,
        AddressZip: this.headquarter.addressZip
      }
      this.loading.checkHeadquarter = true
      return client.checkHeadquarter(data)
        .then((res) => {
          this.loading.checkHeadquarter = false
          return res.data.validated
        })
        .catch((res) => {
          this.displayErrors(res);
          this.loading.checkHeadquarter = false
          return false
        })
    },

    checkClient() {
      let data = {
        ClientName: this.client.name,
        ShortName: this.client.shortName,
        SCAFileName: this.client.scaFileName,
        MxnFundsTransferInfo: this.client.mxnFundsTransferInfo,
        UsdFundsTransferInfo: this.client.usdFundsTransferInfo,
        scheduleDayInvoice: this.client.scheduleDayInvoice,
        code: this.client.code,
        DarwinAccount: this.client.darwinAccount,
        color: this.client.color
      }
      this.loading.checkClient = true
      return client.checkClient(data)
        .then((res) => {
          this.loading.checkClient = false
          return res.data.validated
        })
        .catch((res) => {
          this.displayErrors(res);
          this.loading.checkClient = false
          return false
        })
    },

    setScaFileName(){
      this.client.scaFileName = this.client.shortName.trim() + '.xlsx'
    }
  },
  mounted() {
    this.getCompanies();
    this.client.scheduleDayInvoice = this.days[0].id
  },
  mixins: [loading, validate],
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading('add-client-loading')
      } else {
        this.closeLoading('add-client-loading')
      }
    }
  }
}
</script>


<style>
.detail-th {
  padding: 0;
}

.linea {
  width: 40%;
  border-top: 3px solid #BC1300;
  position: relative;
  top: 10px;
  float: left;
}

.leyenda {
  width: 20%;
  font-weight: bold;
  font-size: 16px;
  float: left;
}

.vue-swatches__trigger__wrapper {
  display: block;
  cursor: pointer
}
</style>
